import { render, staticRenderFns } from "./NoOrders.vue?vue&type=template&id=ed208afe&scoped=true&"
import script from "./NoOrders.vue?vue&type=script&lang=js&"
export * from "./NoOrders.vue?vue&type=script&lang=js&"
import style0 from "./NoOrders.vue?vue&type=style&index=0&id=ed208afe&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed208afe",
  null
  
)

export default component.exports